import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from "pinia";
import { computed } from "vue";
import invocationsGridConfig from "@/components/Grid/configs/invocations";
import invocationsBatchConfig from "@/components/Grid/configs/invocationsBatch";
import invocationsHistoryGridConfig from "@/components/Grid/configs/invocationsHistory";
import invocationsWorkflowGridConfig from "@/components/Grid/configs/invocationsWorkflow";
import { useUserStore } from "@/stores/userStore";
import Heading from "../Common/Heading.vue";
import UtcDate from "../UtcDate.vue";
import WorkflowInvocationState from "../WorkflowInvocationState/WorkflowInvocationState.vue";
import GridList from "@/components/Grid/GridList.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GridInvocation',
    props: {
        noInvocationsMessage: { default: "No Workflow Invocations to display" },
        headerMessage: { default: "" },
        ownerGrid: { type: Boolean, default: true },
        filteredFor: { default: undefined },
        invocationsList: { default: undefined }
    },
    setup(__props) {
        const props = __props;
        const { currentUser } = storeToRefs(useUserStore());
        const forStoredWorkflow = computed(() => props.filteredFor?.type === "StoredWorkflow");
        const forHistory = computed(() => props.filteredFor?.type === "History");
        const forBatch = computed(() => !!props.invocationsList?.length);
        const effectiveNoInvocationsMessage = computed(() => {
            let message = props.noInvocationsMessage;
            if (props.filteredFor) {
                message += ` for ${props.filteredFor?.name}`;
            }
            return message;
        });
        const effectiveTitle = computed(() => {
            let retVal = `Workflow Invocations`;
            const type = props.filteredFor?.type === "StoredWorkflow" ? "Workflow" : "History";
            if (props.filteredFor && props.filteredFor?.name) {
                retVal += ` for ${type} "${props.filteredFor.name}"`;
            }
            return retVal;
        });
        const extraProps = computed(() => {
            if (forBatch.value) {
                return Object.fromEntries(props.invocationsList.map((invocation) => [invocation.id, invocation]));
            }
            const params = {};
            if (forStoredWorkflow.value) {
                params.workflow_id = props.filteredFor?.id;
            }
            if (forHistory.value) {
                params.history_id = props.filteredFor?.id;
            }
            if (!props.ownerGrid) {
                params.include_terminal = false;
            }
            else if (currentUser.value && !currentUser.value?.isAnonymous) {
                params.user_id = currentUser.value?.id;
            }
            return params;
        });
        let gridConfig;
        if (forBatch.value) {
            gridConfig = invocationsBatchConfig;
        }
        else if (forStoredWorkflow.value) {
            gridConfig = invocationsWorkflowGridConfig;
        }
        else if (forHistory.value) {
            gridConfig = invocationsHistoryGridConfig;
        }
        else {
            gridConfig = invocationsGridConfig;
        }
        function refreshTable() {
            // TODO: Implement
        }
        return { __sfc: true, props, currentUser, forStoredWorkflow, forHistory, forBatch, effectiveNoInvocationsMessage, effectiveTitle, extraProps, gridConfig, refreshTable, Heading, UtcDate, WorkflowInvocationState, GridList };
    }
});
